import LandingPageTestimonials from '@/app/components/LandingPage/LandingPageTestimonials';
import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

import { businessCaseStudies, businessCaseStudiesOR4 } from './data/data';

const BusinessCaseStudy = (): JSX.Element => {
  //TODO: GROW-1607 clean up Gen3 clean up
  const OR4Enabled = useOuraGen4Enabled();
  return (
    <section className="pb-20" data-cy="business-case-study">
      <LandingPageTestimonials
        testimonials={OR4Enabled ? businessCaseStudiesOR4 : businessCaseStudies}
        theme="darkSandstone"
      />
    </section>
  );
};

export default BusinessCaseStudy;
